import { NgModule } from '@angular/core';
import { ReferralSelectionComponent } from './referral-selection/referral-selection.component';
import { ReferralAddComponent } from './referral-add/referral-add.component';
import { SharedModule } from '../shared/shared.module';
import { ReferralComponent } from './referral.component';
import { CommunityProviderProgramSearchListService } from '../core/service/grid-data/grid-data-community-search.service';
import { CommunitySearchModule } from '../shared/community-search/community-search.module';

@NgModule({
  declarations: [
    ReferralSelectionComponent,
    ReferralAddComponent,
    ReferralComponent
  ],
  imports: [
    SharedModule,
    CommunitySearchModule
  ],
  exports: [
    ReferralComponent,
  ],
  providers: [
    CommunityProviderProgramSearchListService
  ]
})
export class ReferralModule { }
